module.exports = __webpack_public_path__ + "img/no-logistics.0a08592a.svg";